<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'AuditModal',
})
</script>
<template>
    <a-modal title="审核" :width="1200" :open="true" :footer="false" @cancel="() => emit('cancel')" class="audit-modal">
        <div class="audit-container">
            <!-- ====== 顶部：核心身份信息 + 审核操作 ====== -->
            <div class="identity-card">
                <a-row :gutter="16" align="middle">
                    <!-- 左侧：身份信息 -->
                    <a-col :span="11">
                        <a-space size="large" align="start">
                            <a-avatar :size="72"
                                :src="$store.state.user.image_domain + props.detailData.wechat_picture">
                                {{ props.detailData.customer_name?.charAt(0) || '?' }}
                            </a-avatar>
                            <div class="identity-info">
                                <div class="identity-name">
                                    <span class="name">{{ isEmpty(props.detailData.customer_name) }}</span>
                                    <a-tag color="blue" bordered>{{ isEmpty(props.detailData.job_title) }}</a-tag>
                                </div>
                                <div class="identity-company">
                                    <span class="label">就职公司：</span>
                                    <span class="value">{{ isEmpty(props.detailData.company_name) }}</span>
                                </div>
                                <div class="identity-contact">
                                    <a-space size="middle">
                                        <span>电话：{{ isEmpty(props.detailData.customer_tel) }}</span>
                                        <span>邮箱：{{ isEmpty(props.detailData.mail_address) }}</span>
                                    </a-space>
                                </div>
                            </div>
                        </a-space>
                    </a-col>

                    <!-- 右侧：审核操作 -->
                    <a-col :span="13">
                        <div class="audit-actions-card">
                            <div class="audit-title">
                                <span>审核操作</span>
                            </div>
                            <div class="audit-form">
                                <a-row>
                                    <a-col :span="12">
                                        <div class="form-item">
                                            <div class="form-label">
                                                <span class="required">*</span> 所在城市
                                            </div>
                                            <a-input v-model:value="formData.company_city" placeholder="请输入所在城市"
                                                size="small" style="width:200px" />
                                            <div class="city-tags">
                                                如：
                                                <a-tag color="green" @click="formData.company_city = '长沙'">长沙</a-tag>
                                                <a-tag color="green" @click="formData.company_city = '西安'">西安</a-tag>
                                            </div>
                                        </div>

                                    </a-col>
                                    <a-col :span="12">
                                        <div class="form-item">
                                            <div class="form-label">操作意见</div>
                                            <a-input v-model:value="formData.reason" placeholder="选填" size="small" />
                                        </div>
                                        <div class="form-item">
                                            <a-space>
                                                <a-popconfirm title="确定不通过?" @confirm="verificatioChange(2)">
                                                    <a-button type="primary" danger size="small"
                                                        :loading="loading && actionType === 'reject'">
                                                        不通过
                                                    </a-button>
                                                </a-popconfirm>
                                                <a-popconfirm title="确定通过?" @confirm="verificatioChange(1)">
                                                    <a-button type="primary" size="small"
                                                        :loading="loading && actionType === 'approve'">
                                                        通过
                                                    </a-button>
                                                </a-popconfirm>
                                            </a-space>
                                        </div>
                                    </a-col>
                                </a-row>


                            </div>
                        </div>
                    </a-col>
                </a-row>
            </div>

            <!-- ====== 详细信息网格 ====== -->
            <a-row :gutter="[16, 16]">
                <!-- 公司信息 -->
                <a-col :xs="24" :md="12">
                    <a-card size="small" class="info-card" :bordered="true">
                        <template #title>
                            <span>公司信息</span>
                            <span class="action-icons">
                                <template v-if="editingType === 'company'">
                                    <CloseOutlined class="cancel-icon" @click="cancelEdit" />
                                    <CheckOutlined class="save-icon" @click="saveEdit('company')" />
                                </template>
                                <EditOutlined v-else class="edit-icon" @click="toggleEdit('company')" />
                            </span>
                        </template>
                        <a-descriptions :column="1" size="small" bordered>
                            <a-descriptions-item label="就职公司名称">
                                <a-input v-if="editingType === 'company'" v-model:value="editData.company_name"
                                    size="small" placeholder="请输入公司名称" />
                                <span v-else>{{ isEmpty(props.detailData.company_name) }}</span>
                            </a-descriptions-item>
                            <a-descriptions-item label="就职公司统一社会信用代码">
                                <a-input v-if="editingType === 'company'"
                                    v-model:value="editData.finance_social_credit_code" size="small"
                                    placeholder="请输入统一社会信用代码" />
                                <span v-else>{{ isEmpty(props.detailData.finance_social_credit_code) }}</span>
                            </a-descriptions-item>
                            <a-descriptions-item label="就职公司地址">
                                <a-input v-if="editingType === 'company'" v-model:value="editData.company_address"
                                    size="small" placeholder="请输入公司地址" />
                                <span v-else>{{ isEmpty(props.detailData.company_address) }}</span>
                            </a-descriptions-item>
                            <a-descriptions-item label="公司营业执照照片">
                                <!-- 编辑模式：显示上传 -->
                                <div v-if="editingType === 'company'">
                                    <a-upload :action="$store.state.user.image_domain + '/admin/v1/upload'"
                                        :headers="{ Authorization: $store.state.user.token }"
                                        :file-list="editFileList.company_business_license"
                                        @change="(info) => handleFileChange(info, 'company_business_license')"
                                        list-type="picture-card" :max-count="1">
                                        <div v-if="editFileList.company_business_license?.length === 0">
                                            <PlusOutlined />
                                            <div style="margin-top: 8px">上传</div>
                                        </div>
                                    </a-upload>
                                    <div v-if="editData.company_business_license" class="upload-tip">
                                        当前图片：<a-image :width="60" :height="60"
                                            :src="$store.state.user.image_domain + editData.company_business_license"></a-image>
                                    </div>
                                </div>
                                <!-- 查看模式：显示图片 -->
                                <div v-else>
                                    <div v-if="props.detailData.company_business_license">
                                        <a-image :width="100" :height="100"
                                            :src="$store.state.user.image_domain + props.detailData.company_business_license">
                                        </a-image>
                                    </div>
                                    <div v-else>无</div>
                                </div>
                            </a-descriptions-item>
                        </a-descriptions>
                    </a-card>
                </a-col>
                <!-- 个人信息 -->
                <a-col :xs="24" :md="12">
                    <a-card size="small" class="info-card" :bordered="true">
                        <template #title>
                            <span>个人信息</span>
                            <span class="action-icons">
                                <template v-if="editingType === 'personal'">
                                    <CloseOutlined class="cancel-icon" @click="cancelEdit" />
                                    <CheckOutlined class="save-icon" @click="saveEdit('personal')" />
                                </template>
                                <EditOutlined v-else class="edit-icon" @click="toggleEdit('personal')" />
                            </span>
                        </template>
                        <a-descriptions :column="1" size="small" bordered>
                            <a-descriptions-item label="姓名">
                                <a-input v-if="editingType === 'personal'" v-model:value="editData.customer_name"
                                    size="small" placeholder="请输入姓名" />
                                <span v-else>{{ isEmpty(props.detailData.customer_name) }}</span>
                            </a-descriptions-item>
                            <a-descriptions-item label="职位名称">
                                <a-input v-if="editingType === 'personal'" v-model:value="editData.job_title"
                                    size="small" placeholder="请输入职位名称" />
                                <span v-else>{{ isEmpty(props.detailData.job_title) }}</span>
                            </a-descriptions-item>
                            <a-descriptions-item label="手机号码">
                                <a-input v-if="editingType === 'personal'" v-model:value="editData.customer_tel"
                                    size="small" placeholder="请输入手机号码" />
                                <span v-else>{{ isEmpty(props.detailData.customer_tel) }}</span>
                            </a-descriptions-item>
                            <a-descriptions-item label="其他号码">
                                <a-input v-if="editingType === 'personal'" v-model:value="editData.exigency_tel"
                                    size="small" placeholder="请输入其他号码" />
                                <span v-else>{{ isEmpty(props.detailData.exigency_tel) }}</span>
                            </a-descriptions-item>
                            <a-descriptions-item label="证明材料">
                                <!-- 编辑模式：显示上传 -->
                                <div v-if="editingType === 'personal'">
                                    <a-upload :action="$store.state.user.image_domain + '/admin/v1/upload'"
                                        :headers="{ Authorization: $store.state.user.token }"
                                        :file-list="editFileList.job_certificate"
                                        @change="(info) => handleFileChange(info, 'job_certificate')"
                                        list-type="picture-card" :max-count="1">
                                        <div v-if="editFileList.job_certificate?.length === 0">
                                            <PlusOutlined />
                                            <div style="margin-top: 8px">上传</div>
                                        </div>
                                    </a-upload>
                                    <div v-if="editData.job_certificate" class="upload-tip">
                                        当前文件：<a :href="$store.state.user.image_domain + editData.job_certificate"
                                            target="_blank">查看文件</a>
                                    </div>
                                </div>
                                <!-- 查看模式：显示文件 -->
                                <div v-else>
                                    <div v-if="props.detailData.job_certificate">
                                        <a :href="$store.state.user.image_domain + props.detailData.job_certificate"
                                            target="_blank">
                                            查看文件
                                        </a>
                                    </div>
                                    <div v-else>无</div>
                                </div>
                            </a-descriptions-item>
                        </a-descriptions>
                    </a-card>
                </a-col>

                <!-- 微信信息 -->
                <a-col :xs="24" :md="12">
                    <a-card size="small" class="info-card" :bordered="true">
                        <template #title>
                            <span>微信信息</span>
                            <span class="action-icons">
                                <template v-if="editingType === 'wechat'">
                                    <CloseOutlined class="cancel-icon" @click="cancelEdit" />
                                    <CheckOutlined class="save-icon" @click="saveEdit('wechat')" />
                                </template>
                                <EditOutlined v-else class="edit-icon" @click="toggleEdit('wechat')" />
                            </span>
                        </template>
                        <a-descriptions :column="1" size="small" bordered>
                            <a-descriptions-item label="微信号">
                                <a-input v-if="editingType === 'wechat'" v-model:value="editData.wechat_id" size="small"
                                    placeholder="请输入微信号" />
                                <span v-else>{{ isEmpty(props.detailData.wechat_id) }}</span>
                            </a-descriptions-item>
                            <a-descriptions-item label="微信昵称">
                                <a-input v-if="editingType === 'wechat'" v-model:value="editData.wechat_name"
                                    size="small" placeholder="请输入微信昵称" />
                                <span v-else>{{ isEmpty(props.detailData.wechat_name) }}</span>
                            </a-descriptions-item>
                            <a-descriptions-item label="微信头像">
                                <!-- 编辑模式：显示上传 -->
                                <div v-if="editingType === 'wechat'">
                                    <a-upload :action="$store.state.user.image_domain + '/admin/v1/upload'"
                                        :headers="{ Authorization: $store.state.user.token }"
                                        :file-list="editFileList.wechat_picture"
                                        @change="(info) => handleFileChange(info, 'wechat_picture')"
                                        list-type="picture-card" :max-count="1">
                                        <div v-if="editFileList.wechat_picture?.length === 0">
                                            <PlusOutlined />
                                            <div style="margin-top: 8px">上传</div>
                                        </div>
                                    </a-upload>
                                    <div v-if="editData.wechat_picture" class="upload-tip">
                                        当前图片：<a-image :width="60" :height="60"
                                            :src="$store.state.user.image_domain + editData.wechat_picture"></a-image>
                                    </div>
                                </div>
                                <!-- 查看模式：显示图片 -->
                                <div v-else>
                                    <a-image v-if="props.detailData.wechat_picture" :width="100" :height="100"
                                        :src="$store.state.user.image_domain + props.detailData.wechat_picture">
                                    </a-image>
                                    <div v-else>无</div>
                                </div>
                            </a-descriptions-item>
                        </a-descriptions>
                    </a-card>
                </a-col>

                <!-- 身份证信息 -->
                <a-col :xs="24" :md="12">
                    <a-card size="small" class="info-card" :bordered="true">
                        <template #title>
                            <span>身份证信息</span>
                            <span class="action-icons">
                                <template v-if="editingType === 'idCard'">
                                    <CloseOutlined class="cancel-icon" @click="cancelEdit" />
                                    <CheckOutlined class="save-icon" @click="saveEdit('idCard')" />
                                </template>
                                <EditOutlined v-else class="edit-icon" @click="toggleEdit('idCard')" />
                            </span>
                        </template>
                        <a-descriptions :column="1" size="small" bordered>
                            <!-- 身份证号码 + 民族 一行 -->
                            <a-descriptions-item label="身份证号码 / 民族">
                                <template v-if="editingType === 'idCard'">
                                    <a-space direction="vertical" style="width: 100%">
                                        <a-input v-model:value="editData.identity_card_number" size="small"
                                            placeholder="请输入身份证号码" />
                                        <a-input v-model:value="editData.nationality" size="small"
                                            placeholder="请输入民族" />
                                    </a-space>
                                </template>
                                <template v-else>
                                    <div>{{ isEmpty(props.detailData.identity_card_number) }} / {{
                                        isEmpty(props.detailData.nationality) }}</div>
                                </template>
                            </a-descriptions-item>

                            <!-- 住所 单独一行 -->
                            <a-descriptions-item label="住所">
                                <a-input v-if="editingType === 'idCard'" v-model:value="editData.identity_card_address"
                                    size="small" placeholder="请输入住所" />
                                <span v-else>{{ isEmpty(props.detailData.identity_card_address) }}</span>
                            </a-descriptions-item>

                            <!-- 身份证有效期开始时间 + 结束时间 一行 -->
                            <a-descriptions-item label="有效期开始 / 结束时间">
                                <template v-if="editingType === 'idCard'">
                                    <a-space direction="vertical" style="width: 100%">
                                        <a-input v-model:value="editData.identity_card_start_time" size="small"
                                            placeholder="请输入有效期开始时间" />
                                        <a-input v-model:value="editData.identity_card_expiration_time" size="small"
                                            placeholder="请输入有效期结束时间" />
                                    </a-space>
                                </template>
                                <template v-else>
                                    <div>{{ isEmpty(props.detailData.identity_card_start_time) }} / {{
                                        isEmpty(props.detailData.identity_card_expiration_time) }}</div>
                                </template>
                            </a-descriptions-item>

                            <!-- 身份证人像面照片 + 国徽面照片 一行 -->
                            <a-descriptions-item label="人像面 / 国徽面照片">
                                <template v-if="editingType === 'idCard'">
                                    <a-space direction="vertical" style="width: 100%">
                                        <div>
                                            <span style="font-size:12px;color:#999;margin-right:8px;">人像面：</span>
                                            <a-upload :action="$store.state.user.image_domain + '/admin/v1/upload'"
                                                :headers="{ Authorization: $store.state.user.token }"
                                                :file-list="editFileList.identity_card_front"
                                                @change="(info) => handleFileChange(info, 'identity_card_front')"
                                                list-type="picture-card" :max-count="1">
                                                <div v-if="editFileList.identity_card_front?.length === 0">
                                                    <PlusOutlined />
                                                    <div style="margin-top: 8px">上传</div>
                                                </div>
                                            </a-upload>
                                            <div v-if="editData.identity_card_front" class="upload-tip">
                                                当前图片：<a-image :width="60" :height="60"
                                                    :src="$store.state.user.image_domain + editData.identity_card_front"></a-image>
                                            </div>
                                        </div>
                                        <div>
                                            <span style="font-size:12px;color:#999;margin-right:8px;">国徽面：</span>
                                            <a-upload :action="$store.state.user.image_domain + '/admin/v1/upload'"
                                                :headers="{ Authorization: $store.state.user.token }"
                                                :file-list="editFileList.identity_card_contrary"
                                                @change="(info) => handleFileChange(info, 'identity_card_contrary')"
                                                list-type="picture-card" :max-count="1">
                                                <div v-if="editFileList.identity_card_contrary?.length === 0">
                                                    <PlusOutlined />
                                                    <div style="margin-top: 8px">上传</div>
                                                </div>
                                            </a-upload>
                                            <div v-if="editData.identity_card_contrary" class="upload-tip">
                                                当前图片：<a-image :width="60" :height="60"
                                                    :src="$store.state.user.image_domain + editData.identity_card_contrary"></a-image>
                                            </div>
                                        </div>
                                    </a-space>
                                </template>
                                <template v-else>
                                    <a-space>
                                        <div>
                                            <span style="font-size:12px;color:#999;">人像面：</span>
                                            <a-image v-if="props.detailData.identity_card_front" :width="100"
                                                :height="70"
                                                :src="$store.state.user.image_domain + props.detailData.identity_card_front">
                                            </a-image>
                                            <span v-else>无</span>
                                        </div>
                                        <div>
                                            <span style="font-size:12px;color:#999;">国徽面：</span>
                                            <a-image v-if="props.detailData.identity_card_contrary" :width="100"
                                                :height="70"
                                                :src="$store.state.user.image_domain + props.detailData.identity_card_contrary">
                                            </a-image>
                                            <span v-else>无</span>
                                        </div>
                                    </a-space>
                                </template>
                            </a-descriptions-item>
                        </a-descriptions>
                    </a-card>
                </a-col>
            </a-row>
        </div>
    </a-modal>
</template>

<script lang="ts" setup name="AuditModal">
import { reactive, ref } from 'vue'
import { message } from 'ant-design-vue'
import { useStore } from 'vuex'
import { EditOutlined, CheckOutlined, CloseOutlined, PlusOutlined } from '@ant-design/icons-vue'
import baseService from '@/utils/http/axios'

const $store = useStore()

const props = defineProps({
    detailData: {
        type: Object,
        default: () => null
    }
})

const emit = defineEmits(['cancel', 'update'])

// ====== 行内编辑状态 ======
const editingType = ref('') // '' 表示不编辑，'company' 编辑公司，'personal' 编辑个人，'wechat' 编辑微信，'idCard' 编辑身份证

// ====== 编辑数据缓存 ======
const editData = reactive({
    // 公司信息
    company_name: '',
    finance_social_credit_code: '',
    company_address: '',
    company_business_license: '',
    // 个人信息
    customer_name: '',
    job_title: '',
    customer_tel: '',
    exigency_tel: '',
    job_certificate: '',
    // 微信信息
    wechat_id: '',
    wechat_name: '',
    wechat_picture: '',
    // 身份证信息
    identity_card_number: '',
    nationality: '',
    identity_card_address: '',
    identity_card_start_time: '',
    identity_card_expiration_time: '',
    identity_card_front: '',
    identity_card_contrary: ''
})

// ====== 文件列表（用于上传组件） ======
const editFileList = reactive({
    company_business_license: [],
    job_certificate: [],
    wechat_picture: [],
    identity_card_front: [],
    identity_card_contrary: []
})

// ====== 审核操作 Loading 状态 ======
const loading = ref(false)
const actionType = ref('') // 'approve' 或 'reject'

// ====== 审核表单 ======
const formData = reactive({
    company_city: '西安',
    reason: ''
})

// ====== 工具函数：判断是否为空 ======
const isEmpty = (val: any) => {
    if (val && val.toString().length > 0) {
        return val
    }
    return '无'
}

// ====== 切换编辑状态 ======
const toggleEdit = (type: string) => {
    // 如果已经是在编辑这个卡片，就取消编辑
    if (editingType.value === type) {
        cancelEdit()
        return
    }

    // 清空编辑数据
    Object.keys(editData).forEach(key => {
        editData[key] = ''
    })
    Object.keys(editFileList).forEach(key => {
        editFileList[key] = []
    })

    // 根据类型填充数据
    const fieldMap = {
        company: ['company_name', 'finance_social_credit_code', 'company_address', 'company_business_license'],
        personal: ['customer_name', 'job_title', 'customer_tel', 'exigency_tel', 'job_certificate'],
        wechat: ['wechat_id', 'wechat_name', 'wechat_picture'],
        idCard: ['identity_card_number', 'nationality', 'identity_card_address', 'identity_card_start_time', 'identity_card_expiration_time', 'identity_card_front', 'identity_card_contrary']
    }

    const fields = fieldMap[type] || []
    fields.forEach(field => {
        editData[field] = props.detailData[field] || ''
    })

    editingType.value = type
}

// ====== 取消编辑 ======
const cancelEdit = () => {
    editingType.value = ''
    Object.keys(editData).forEach(key => {
        editData[key] = ''
    })
    Object.keys(editFileList).forEach(key => {
        editFileList[key] = []
    })
}

// ====== 文件上传处理 ======
const handleFileChange = (info: any, fieldName: string) => {
    editFileList[fieldName] = info.fileList

    if (info.file.status === 'done') {
        // 上传成功，获取图片URL
        const response = info.file.response
        if (response && (response.code === 200 || response.code === 0)) {
            const url = response.data?.url || response.url || ''
            if (url) {
                editData[fieldName] = url
                message.success('上传成功')
            }
        } else {
            message.error(response?.msg || '上传失败')
        }
    } else if (info.file.status === 'error') {
        message.error('上传失败，请重试')
    }
}

// ====== 保存编辑 ======
const saveEdit = async (type: string) => {
    // 构建提交数据
    const submitData = {
        id: props.detailData.id
    }

    // 根据类型获取要提交的字段
    const fieldMap = {
        company: ['company_name', 'finance_social_credit_code', 'company_address', 'company_business_license'],
        personal: ['customer_name', 'job_title', 'customer_tel', 'exigency_tel', 'job_certificate'],
        wechat: ['wechat_id', 'wechat_name', 'wechat_picture'],
        idCard: ['identity_card_number', 'nationality', 'identity_card_address', 'identity_card_start_time', 'identity_card_expiration_time', 'identity_card_front', 'identity_card_contrary']
    }

    const fields = fieldMap[type] || []
    let hasChange = false

    // 只提交有变化的字段
    fields.forEach(field => {
        if (editData[field] !== props.detailData[field]) {
            submitData[field] = editData[field]
            hasChange = true
        }
    })

    if (!hasChange) {
        message.info('没有修改内容')
        editingType.value = ''
        return
    }

    try {
        // 根据类型调用不同接口
        const urlMap = {
            company: '/admin/v1/filings/updateCompany',
            personal: '/admin/v1/filings/updatePersonal',
            wechat: '/admin/v1/filings/updateWechat',
            idCard: '/admin/v1/filings/updateIdCard'
        }

        const url = urlMap[type]

        const response = await baseService({
            url: url,
            method: 'post',
            data: submitData
        })

        if (response.code === 200 || response.code === 0) {
            message.success('修改成功')
            // 更新本地数据
            Object.keys(submitData).forEach(key => {
                if (key !== 'id') {
                    props.detailData[key] = submitData[key]
                }
            })
            emit('update', props.detailData)
            cancelEdit()
        } else {
            message.error(response.msg || '修改失败')
        }
    } catch (error: any) {
        message.error(error?.msg || '修改失败，请重试')
    }
}

// ====== 审核操作 ======
const verificatioChange = (type: number) => {
    // 验证城市是否填写
    if (!formData.company_city) {
        message.error('请填写所在城市')
        return
    }

    // 设置loading
    loading.value = true
    actionType.value = type === 1 ? 'approve' : 'reject'

    const requestParam = {
        url: '/admin/v1/filingsCheck/' + props.detailData.id,
        method: 'put',
        data: {
            status: type,
            company_city: formData.company_city,
            reason: formData.reason
        }
    }

    baseService(requestParam)
        .then(() => {
            message.success('操作成功')
            emit('cancel')
        })
        .catch((error) => {
            if (error?.msg) {
                message.error(error.msg)
            } else {
                message.error('操作失败，请联系管理员')
            }
        })
        .finally(() => {
            loading.value = false
            actionType.value = ''
        })
}
</script>

<style lang="less" scoped>
.audit-modal {
    :deep(.ant-modal-body) {
        padding: 24px;
        max-height: 80vh;
        overflow-y: auto;
    }
}

.audit-container {
    .identity-card {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border-radius: 12px;
        padding: 20px 24px;
        margin-bottom: 20px;
        color: #fff;

        .identity-info {
            .identity-name {
                display: flex;
                align-items: center;
                gap: 8px;
                flex-wrap: wrap;
                margin-bottom: 6px;

                .name {
                    font-size: 22px;
                    font-weight: 600;
                }

                :deep(.ant-tag) {
                    font-size: 13px;
                    border-radius: 4px;
                    margin: 0;
                }
            }

            .identity-company {
                font-size: 14px;
                margin-bottom: 4px;
                opacity: 0.95;

                .label {
                    opacity: 0.7;
                }

                .value {
                    font-weight: 500;
                }
            }

            .identity-contact {
                font-size: 14px;
                opacity: 0.9;
            }
        }

        // 右侧审核操作样式
        .audit-actions-card {
            background: rgba(255, 255, 255, 0.15);
            backdrop-filter: blur(10px);
            border-radius: 8px;
            padding: 12px 16px;
            border: 1px solid rgba(255, 255, 255, 0.2);

            .audit-title {
                font-size: 14px;
                font-weight: 600;
                margin-bottom: 10px;
                color: #fff;
                letter-spacing: 0.5px;
            }

            .audit-form {
                .form-item {
                    margin-bottom: 8px;

                    &:last-child {
                        margin-bottom: 0;
                    }

                    .form-label {
                        font-size: 12px;
                        color: rgba(255, 255, 255, 0.85);
                        margin-bottom: 4px;
                        font-weight: 500;

                        .required {
                            color: #ff4d4f;
                            margin-right: 2px;
                        }
                    }

                    .city-tags {
                        margin-top: 4px;

                        :deep(.ant-tag) {
                            cursor: pointer;
                            transition: all 0.3s;
                            font-size: 12px;
                            padding: 0 6px;
                            line-height: 20px;
                            background: rgba(255, 255, 255, 0.2);
                            border-color: rgba(255, 255, 255, 0.3);
                            color: #fff;

                            &:hover {
                                transform: scale(1.05);
                                opacity: 0.8;
                            }
                        }
                    }

                    :deep(.ant-input) {
                        background: rgba(255, 255, 255, 0.2);
                        border-color: rgba(255, 255, 255, 0.3);
                        color: #fff;
                        height: 28px;

                        &::placeholder {
                            color: rgba(255, 255, 255, 0.6);
                        }

                        &:hover,
                        &:focus {
                            border-color: rgba(255, 255, 255, 0.6);
                            background: rgba(255, 255, 255, 0.3);
                        }
                    }

                    :deep(.ant-btn) {
                        height: 28px;
                        font-size: 13px;
                    }
                }
            }
        }
    }

    .info-card {
        height: 100%;
        border-radius: 8px;
        position: relative;

        :deep(.ant-card-head) {
            background: #fafafa;
            border-bottom: 1px solid #f0f0f0;
            padding: 0 16px;
            min-height: 44px;

            .ant-card-head-title {
                padding: 10px 0;
                font-weight: 600;
                font-size: 14px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
            }
        }

        :deep(.ant-card-body) {
            padding: 12px 16px;
        }

        :deep(.ant-descriptions) {
            .ant-descriptions-item-label {
                width: 160px;
                background: #fafafa;
                font-weight: 500;
                color: #666;
            }

            .ant-descriptions-item-content {
                padding: 8px 12px;

                .ant-input {
                    width: 100%;
                }
            }
        }

        .action-icons {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-left: auto;
        }

        .edit-icon {
            color: #1890ff;
            font-size: 16px;
            cursor: pointer;
            transition: all 0.3s;

            &:hover {
                color: #40a9ff;
                transform: scale(1.1);
            }
        }

        .save-icon {
            color: #52c41a;
            font-size: 16px;
            cursor: pointer;
            transition: all 0.3s;

            &:hover {
                color: #73d13d;
                transform: scale(1.1);
            }
        }

        .cancel-icon {
            color: #ff4d4f;
            font-size: 16px;
            cursor: pointer;
            transition: all 0.3s;

            &:hover {
                color: #ff7875;
                transform: scale(1.1);
            }
        }
    }
}

.upload-tip {
    margin-top: 8px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: #666;
}

.mr-1x {
    margin-right: 8px;
}

.mb-1x {
    margin-bottom: 8px;
}

// 身份证照片显示样式优化
:deep(.ant-descriptions-item-content) {
    .ant-image {
        margin-right: 8px;
    }
}

@media (max-width: 768px) {
    .identity-card {
        .identity-info {
            .identity-name {
                .name {
                    font-size: 18px !important;
                }
            }
        }

        .audit-actions-card {
            margin-top: 12px;
        }
    }
}
</style>
